import {getTestProps} from '@benchling/js-test-utils';
import React from 'react';

import {resolveExtensionIconSrc} from 'dev-platform/extensionIconMapper';
import {ToolCallStatus} from 'llm/chat-library/progress/ProgressTypes';
import {getToolCallVisualOpacity} from 'llm/chat-library/progress/ToolCallVisualState';
import {isGlyphIcon, ToolIconSource} from 'llm/chat-library/tool-details/types';
import {useLLMShimmerIconContainerClassName} from 'llm/loading/LLMShimmer';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

export interface ToolIconDisplayProps {
  icon: ToolIconSource;
  glyphClassName?: string;
  imgClassName?: string;
  status?: ToolCallStatus;
  /** Icon color; should match the tool label text color. */
  iconColor?: string;
}

export function ToolIconDisplay({
  icon,
  glyphClassName,
  imgClassName,
  status = ToolCallStatus.COMPLETED,
  iconColor,
}: ToolIconDisplayProps): JSX.Element {
  const iconContainerClassName = useLLMShimmerIconContainerClassName();
  const opacity = getToolCallVisualOpacity(status);

  const iconElement = isGlyphIcon(icon) ? (
    <BenchlingIcon icon={icon.iconName} className={glyphClassName} color={iconColor} />
  ) : (
    <img
      src={resolveExtensionIconSrc(icon.iconUrl)}
      alt={`${icon.serverName} icon`}
      className={imgClassName}
    />
  );

  return (
    <span
      className={iconContainerClassName}
      style={{opacity}}
      {...getTestProps({component: 'ToolIconDisplay', element: 'iconContainer'})}
    >
      {iconElement}
    </span>
  );
}
